import { Routes } from '@angular/router';
import { NotOrgComponent } from 'app-not-org.component';
import { DecodeLinkGuard } from '@shared/guards/decode-link.guard';
export const APP_ROUTES: Routes = [
  { path: '', component: NotOrgComponent },
  {
    path: 'p/:token',
    component: NotOrgComponent,
    canActivate: [DecodeLinkGuard],
  },
  {
    path: ':organizacao',
    pathMatch: 'full',
    redirectTo: ':organizacao/assinatura',
  },
];
